
<div class="mainclass">
    <div class="datagrid-toolbar">
            <div>
                <ng-container [ngSwitch]="showIcon" >
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" [disabled]="!canInsert || loading" (click)="adicionarLine($event)" nz-tooltip="Adicionar">
                        <nz-icon nzType="plus"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" (click)="adicionarLine($event)" [disabled]="!canInsert || loading">Adicionar</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div>
                <ng-container [ngSwitch]="showIcon">
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzDanger nzShape="circle" [disabled]="!canDelete || loading" (click)="removeLine($event)" nz-tooltip="Remover">
                        <nz-icon nzType="delete"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" nzDanger (click)="removeLine($event)" [disabled]="!canDelete || loading">Remover</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div [hidden]="!showGetFrom">
                <div [hidden]="(editing | async)">
                    <button nz-button nzType="primary" nzShape="circle" (click)="getFrom($event)">
                        <nz-icon nzType="rollback"></nz-icon>
                    </button>
                </div>
            </div>
            <span class="span1"></span>
            <div class="div1">
                <nz-select class="filter-select" [formControl]="filterSelect" nzMode="multiple" [nzPlaceHolder]="'tree.filtros'|translateTA" [nzOpen]="filterPanelOpen" (nzOpenChange)="filterPanelOpen = $event" [compareWith]="compareFilter">
                    <nz-option *ngFor="let line of filter" [nzValue]="line" [nzLabel]="line.name" nzCustomContent>
                        <div class="item-filter" (mouseover)="showDel=true" (mouseout)="showDel=false">
                            <div class="name">{{line.name}}</div>
                            <div class="space"></div>
                            <div class="editicons">
                                <nz-icon id="editar" nzType="edit" [ngClass]="{'mouseOver':showDel, 'mouseOut':!showDel }" (click)="editFilter($event,line)"></nz-icon>
                                <nz-icon id="excluir" nzType="close" [ngClass]="{'mouseOver':showDel, 'mouseOut':!showDel }" (click)="removeFilter($event,line)"></nz-icon>
                            </div>
                        </div>
                    </nz-option>
                </nz-select>
            </div>
            <span class="span1"></span>
            <div>
                <button nz-button nzType="primary" nzShape="circle" [nz-tooltip]="'tree.addfilter'|translateTA" (click)="openFilter()">
                    <nz-icon nzType="filter"></nz-icon>
                </button>
            </div>
            <span class="span1"></span>
            <div>
                <ng-container [ngSwitch]="showIcon">
                    <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" (click)="apply('total')" nz-tooltip="Atualizar">
                        <nz-icon nzType="reload"></nz-icon>
                    </button>
                    <button *ngSwitchCase="false" nz-button nzType="primary" (click)="apply('total')">Atualizar</button>
                </ng-container>
            </div>
            <span class="span1"></span>
            <div class="div1">
                <nz-select *ngIf="uas.user.companylist.length > 1" class="filter-select" [nzDisabled]="disabled" [(ngModel)]="codecompany" (ngModelChange)="selecting(codecompany)" [nzPlaceHolder]="'escolherEmpresa'|translateTA">
                    <nz-option *ngFor="let data of uas.user.companylist" [nzValue]="data.codecompany" [nzLabel]="data.codecompany + ' - ' + data.companyname"></nz-option>
                </nz-select>
            </div>
            <span class="spacer"></span>
            <ng-container [ngSwitch]="showIcon" *ngIf="showAction" >
                <button *ngSwitchCase="true" nz-button nzType="primary" nzShape="circle" nz-dropdown [nzDropdownMenu]="menuAcoes" [nz-tooltip]="'action'|translateTA">
                    <nz-icon nzType="more"></nz-icon>
                </button>
                <button *ngSwitchCase="false" nz-button nzType="primary" nz-dropdown [nzDropdownMenu]="menuAcoes">{{'action'|translateTA}}</button>
                <nz-dropdown-menu #menuAcoes="nzDropdownMenu">
                    <ul nz-menu>
                        <li nz-menu-item *ngFor="let mainItem of actionList" (click)="callCustomAction(mainItem)">
                            <generic-icon [iconName]="mainItem.ICON" type="google"></generic-icon>
                            <span class="menu-label">{{mainItem.NAME}}</span>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </ng-container>

    </div>

    <div class="main-content">

        <as-split
          unit="percent"
          direction="horizontal"
          gutterAriaLabel="adjustable divider between two views"
          #split="asSplit" (dragEnd)="dragEnd('percent', $event)">

            <as-split-area [size]="leftDiv" #area1="asSplitArea">
                <div class="simpletable">
                    <nz-spin class="tree-spin" [nzSpinning]="treeLoading" nzSize="large">
                        <div class="tree-tools">
                            <nz-input-group [nzPrefix]="searchIconTpl" class="tree-search">
                                <input nz-input [(ngModel)]="searchValue" [placeholder]="'find'|translateTA" />
                            </nz-input-group>
                            <label nz-checkbox [ngModel]="allChecked" (ngModelChange)="checkAll($event)" nz-tooltip="Selecionar todos"></label>
                            <button nz-button nzType="text" nzSize="small" (click)="expandAll = !expandAll" [nz-tooltip]="expandAll ? 'Recolher tudo' : 'Expandir tudo'">
                                <nz-icon [nzType]="expandAll ? 'shrink' : 'arrows-alt'"></nz-icon>
                            </button>
                        </div>
                        <ng-template #searchIconTpl><nz-icon nzType="search"></nz-icon></ng-template>
                        <nz-tree #tree
                            [nzData]="nodes"
                            nzCheckable
                            nzCheckStrictly
                            [nzCheckedKeys]="checkedKeys"
                            [nzSearchValue]="searchValue"
                            [nzExpandAll]="expandAll"
                            (nzClick)="onNodeClick($event)"
                            (nzCheckBoxChange)="onCheckChange($event)">
                        </nz-tree>
                    </nz-spin>
                </div>
            </as-split-area>
            <as-split-area [size]="rightDiv" #area2="asSplitArea">
                <div class="main-content-edit">
                    <editform *ngIf="showEdit"
                        [Row]="parentRow"
                        [entityName]="entityName"
                        [row]="row"
                        [filter]="filter"
                        [userConfig]="userConfig"
                        [tableInformation]="tableInformation"
                        [formViewColumns]="formViewColumns"
                        [formGroup]="formGroup"
                        [evento]="evento"
                        [$$REFERENCES]="$$REFERENCES"
                        [preference]="preference"
                        [customFunction]="theBoundCallback"
                        (saving)="savingForm($event)"
                        [canConfig]="canConfig">
                    </editform>
                </div>
            </as-split-area>
        </as-split>
    </div>


</div>
